import React from 'react';
import { Stack, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { AgreementQuestion } from './DrivingQuestionsConfig';

interface AgreementQuestionsProps {
  questions: AgreementQuestion[];
  reservationData: any;
  onChange: (field: string, value: boolean) => void;
}

const AgreementQuestions: React.FC<AgreementQuestionsProps> = ({ 
  questions, 
  reservationData, 
  onChange 
}) => {
  const visibleQuestions = questions.filter(question => {
    if (!question.showWhen) return true;
    
    const { field, value } = question.showWhen;
    return reservationData[field] === value;
  });

  return (
    <Stack spacing={2}>
      {visibleQuestions.map((question) => (
        <FormControlLabel
          key={question.id}
          control={
            <Checkbox
              checked={reservationData[question.id] as boolean || false}
              onChange={(e) => onChange(question.id, e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">
              {question.text}
              <span style={{ color: 'red' }}>{question.required && '*'}</span>
            </Typography>
          }
        />
      ))}
    </Stack>
  );
};

export default AgreementQuestions;
